import { createBrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage';
import GalleryPage from './pages/GalleryPage';
import OrganizationPage from './pages/OrganizationPage';
import AchievementPage from './pages/AchievementPage';
import GroupPage from './pages/GroupPage';
import { generateDefaultScreenRoute } from './utils/route';

function Root() {
  const defaultRoute = generateDefaultScreenRoute(
    parseInt(process.env.REACT_APP_DEFAULT_SCREEN, 10)
  );

  return (
    <Routes>
      <Route path="/:id" element={<HomePage />} />
      <Route path="/gallery/:id" element={<GalleryPage />} />
      <Route path="/organization/:id" element={<OrganizationPage />} />
      <Route path="/achievement/:id" element={<AchievementPage />} />
      <Route path="/group/:id" element={<GroupPage />} />
      <Route path="*" element={<Navigate to={defaultRoute} replace />} />
    </Routes>
  );
}

const router = createBrowserRouter(
  [
    {
      path: '*',
      Component: Root,
    },
  ],
  {
    basename: '/prevention', // ️ WAJIB untuk cPanel subfolder
  }
);

export default router;
